import { useIM, ParticipantTrackQualityType } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useCurrentUser } from '@/shared/composables/current-user'

type QualityObject = {
  trackName: string
  quality: ParticipantTrackQualityType
}

type Qualities = QualityObject[]

export const useCallSessionsVideoTracksQuality = defineStore('call-session-video-tracks-quality-store', () => {
  const { changeParticipantTrackQualityInConference } = useIM()
  const { currentUser } = useCurrentUser()

  const tracksQualityByCallId = ref<Map<string, Qualities>>(new Map())
  const inFlightTrackKeys = new Set<string>()

  const changeParticipantTrackQuality = async (pServed: string, qualityType: ParticipantTrackQualityType, trackName: string, callId: string) => {
    if (!currentUser.value) {
      return
    }

    const trackKey = `${callId}:${trackName}`
    let qualitiesByCall = tracksQualityByCallId.value.get(callId)
    const qualityByTrack = qualitiesByCall?.find(item => item.trackName === trackName)
    if (qualityByTrack?.quality === qualityType || inFlightTrackKeys.has(trackKey)) {
      return
    }

    inFlightTrackKeys.add(trackKey)
    try {
      const { internalNumber } = currentUser.value
      await changeParticipantTrackQualityInConference({
        pServed,
        internalNumber,
        quality: {
          quality: qualityType,
          enabled: true,
          trackName,
        },
        callId,
      })

      if (!qualitiesByCall) {
        qualitiesByCall = []
        tracksQualityByCallId.value.set(callId, qualitiesByCall)
      }

      if (!qualityByTrack) {
        qualitiesByCall.push({
          trackName,
          quality: qualityType,
        })
      } else {
        qualityByTrack.quality = qualityType
      }
    } catch (e) {
      console.error(e)
    } finally {
      inFlightTrackKeys.delete(trackKey)
    }
  }

  const changeParticipantTrackQualityToLow = (pServed: string, trackName: string, callId: string) => {
    changeParticipantTrackQuality(pServed, 'low', trackName, callId)
  }

  const changeParticipantTrackQualityToHigh = (pServed: string, trackName: string, callId: string) => {
    changeParticipantTrackQuality(pServed, 'high', trackName, callId)
  }

  return {
    changeParticipantTrackQualityToLow,
    changeParticipantTrackQualityToHigh,
  }
})
